module.exports = __webpack_public_path__ + "static/media/location.b5da524e.svg";